import { Form } from 'react-bootstrap';
import { GrowegyTextEditor } from '../../../commons/components/GrowegyTextEditor';
import { DebounceMsConfig } from '../../../config';
import React from 'react';

export const ProgramEditDescription = ({
  setValue,
  initialValue,
  disabled,
  readOnly,
  isInvalid,
  errorText,
  isError,
  errorClassName,
}: {
  setValue: (s: string) => void;
  initialValue: string;
  disabled: boolean;
  readOnly: boolean;
  isInvalid: boolean;
  errorText?: string;
  isError?: boolean;
  errorClassName?: string;
}) => (
  <div>
    <label className="growegy-form__section">Description</label>
    <Form.Group controlId="Notes">
      <div className="program-edit__description-container">
        <GrowegyTextEditor
          setValue={setValue}
          initialValue={initialValue}
          disabled={disabled}
          readOnly={readOnly}
          isInvalid={isInvalid}
          errorText={errorText}
          isError={isError}
          errorClassName={errorClassName}
          dataTest="program-edit__notes"
          debounceMs={DebounceMsConfig.programEditInputDebounceMs}
          placeholder="Add some details…"
        />
      </div>
    </Form.Group>
  </div>
);
